export default "__VITE_ASSET__Bdi8GWR5__"